module.exports = __webpack_public_path__ + "static/media/xt2a0019-wellesebourne.5c109c3b.jpg";